import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 要货申请单
 * 查询要货申请明细
 * @param {*} params
 */
export function apiAddStopDelivery(data) {
  return request({
    url: BASE_API() + '/stopdelivery/addStopDelivery',
    // url: BASE_API() + '/wantgoods/findTicketDetail',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/applyForGoods/stopAndSend.js